<app-ice-alert
  iconWidth="2rem"
  type="info"
  [iconName]="showIcon ? IconNames.ice_mobilbytte : null"
  [ngClass]="{ 'full-width': isFullWidth }"
>
  <div class="mobilbytte-bytte-info">
    {{ mobilBytteBytteText }}
    @if (!hasMobilBytteProductInCart() && mobilBytteAgreementAvailableForUpgrade) {
      <button
        *appAllowSettings="[DealerClaimType.EquipmentUpgrade]"
        class="mobilbytte-bytte-button"
        data-testid="begin-mobilbytte-bytte-button"
        (click)="onMobilBytteBytteClick()"
      >
        Bytt inn nå
      </button>
    }

    @if (isValidatingImei) {
      <app-spinner />
    }
  </div>
</app-ice-alert>
